import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { SwitchViews } from 'src/app/shared/helpers/enums';
import { UserState } from 'src/app/modules/users/store/user.reducer';
import { InvestmentStatus, PaymentOptions } from 'src/app/shared/helpers/backendShortcuts';
import { InvestmentCompanyState } from 'src/app/modules/investment-companies/store/investment-company.reducer';

@Component({
  selector: 'app-detail-view-investments',
  templateUrl: './detail-view-investments.component.html',
  styles: [
    `
      .user-height {
        height: calc(100vh - 500px);
      }
    `
  ]
  // ^fixed height to use scroll and all remaining space
})
export class DetailViewInvestmentsComponent {
  investmentStatus = InvestmentStatus;
  paymentOptions = PaymentOptions;
  switchViews = SwitchViews;
  @Input() showInvestmentCompanyField: boolean;
  @Input() state: Observable<UserState | InvestmentCompanyState>;
}
